<template>
  <div style="display: inline-block;">
    <el-card :body-style="{ padding: '10px' }" shadow="hover" 
        style="margin: 10px; width: 220px; height: 400px; border-width: 5px;"
        :style="{ display: card.pageShow ? 'inline-block' : 'none' }"
        :class='{ flagged: card.flagged, diff: card.design["What"][0].length===0 }'>

        <!-- title -->
        <div style="margin-bottom: 5px; word-break: break-all; overflow-y: auto; height: 20px;" :title="card.name">
            {{card.name}}
        </div>

        <!-- image -->
        <el-image :src="card.pageShow?imageUrl(card.name, 1):''" 
            :preview-src-list="[imageUrl(card.name)]"
            fit="cover" style="width: 100%; height: 200px">
            <!-- lazy -->
            <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
                Loading<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
            </div>
        </el-image>

        <!-- buttons -->
        <el-button type="primary" icon="el-icon-search" v-if="buttonList.includes('recommend')"
            circle @click="recommendByImage(card.name)">
        </el-button>
        <el-button type="info" icon="el-icon-edit" v-if="buttonList.includes('edit')"
            circle @click="handleCardEdit(card.name)">
        </el-button>
        <el-button type="danger" icon="el-icon-delete" v-if="buttonList.includes('delete')"
            circle @click="handleDelete(card.name)">
        </el-button>
        <el-button type="success" icon="el-icon-check" v-if="buttonList.includes('fast')"
            circle @click="fastAnno(card.name)">
        </el-button>
        <el-button type="warning" v-if="buttonList.includes('star')"
            :icon="card.starred?'el-icon-star-on':'el-icon-star-off'" 
            :plain="!card.starred"
            circle @click="starImage(card.name)">
        </el-button>
        <el-button type="warning" icon="el-icon-refresh-right" v-if="buttonList.includes('recover')"
            circle @click="handleRecover(card.name)">
        </el-button>
        
        <!-- information -->
        <div style="padding-top: 10px; cursor: pointer; height: 100px; overflow: auto;" @click="handleClickCard(card.name)">
            <div v-for="dim in rootKeys" :key="dim" style="line-height: 20px;">
            <span>{{ dim }}: {{ String(card.design[dim]).replaceAll(',', ', ') }}</span>
            </div>
            <div style="line-height: 20px;">
            <span>Source: {{ card.design['source'] }}</span>
            </div>
            <div class="bottom clearfix">
            <!-- <time class="time">{{ currentDate }}</time> -->
            <!-- <el-button type="text" class="button">操作按钮</el-button> -->
            </div>
        </div>
    </el-card>

    <!-- 标注设计空间等信息 -->
    <el-dialog
        v-if="editVisible"
        title="修改标注"
        :visible.sync="editVisible"
        width="40%" style="line-height: 20px;">
        <el-image :src="editImageUrl" :preview-src-list="[editImageUrl]"
            fit="cover" style="width: 100%; height: 300px">
            <div slot="placeholder" class="image-slot">
                Loading<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
            </div>
        </el-image>
        <h1>{{ dialogInfo.title }}</h1>
        <div>keywords: [{{ dialogInfo.keywords }}]</div>
        <!-- draw a horizontal line here -->
        <div style="margin: 10px 0; border-bottom: 1px solid #ebeef5;"></div>
        <div>{{ dialogInfo.description }}</div>
        <div style="margin: 10px 0; border-bottom: 1px solid #ebeef5;"></div>
        <div>
            <el-input v-model="editInput" type="textarea" :rows="20"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveEdit">保存解释</el-button>
            <el-button @click="editVisible = false">关 闭</el-button>
        </span>
    </el-dialog>

    <!-- 查看详细信息 -->
    <el-dialog
        v-if="infoVisible"
        title="详细信息"
        :visible.sync="infoVisible"
        width="40%" style="line-height: 20px;">
        <el-button type="warning" @click="setFlag(1)">标 记</el-button>
        <el-button type="info" @click="setFlag(0)">去除标记</el-button>
        <!-- <div style="padding: 20px;">{{ dialogInfo.name }}</div> -->
        <h1>{{ dialogInfo.title }}</h1>
        <div>keywords: [{{ dialogInfo.keywords }}]</div>
        <div style="margin: 10px 0; border-bottom: 1px solid #ebeef5;"></div>
        <div>{{ dialogInfo.description }}</div>
        <div style="margin: 10px 0; border-bottom: 1px solid #ebeef5;"></div>
        <el-image :src="dialogInfo.url" :preview-src-list="[dialogInfo.url]"
            fit="contain" style="width: 100%; padding: 10px;">
            <div slot="placeholder" class="image-slot">
                Loading<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
            </div>
        </el-image>
        <!-- design space annotation -->
        <div style="padding-top: 20px;">
            <div v-for="dim in rootKeys" :key="dim">
                <span>{{ dim }}: {{ dialogInfo.coding===undefined?'':String(dialogInfo.coding[dim]).replaceAll(',', ', ') }}</span>
            </div>
        </div>
        <!-- reasons -->
        <div style="padding-top: 20px;">
            <span> 解释 </span>
            <div v-for="user in Object.keys(dialogInfo.anno)" :key="user">
                <span>{{ user }}: {{ String(dialogInfo.anno[user])}}</span><br>
            </div>
        </div>
        <div style="margin: 20px 0;"></div>
        <div>
            <el-input v-model="user" placeholder="请输入你的名字（留空为匿名）" @input="searchAnno"></el-input>
            <div style="margin: 20px 0;"></div>
            <el-input v-model="annoInput" type="textarea" :rows="4" placeholder="请输入解释内容"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveAnno">保存解释</el-button>
            <el-button @click="infoVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<style>
  .el-header {
    background-color: #d7dee7;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

  .flagged {
    /* background-color: rgb(234, 231, 169); */
    border-color: rgb(234, 231, 169);
    /* border-width: 5px; */
  }

  .diff {
    background-color: rgb(248, 146, 146);
    /* border-color: rgb(248, 146, 146);
    border-width: 5px; */
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>

<script>
import axios from 'axios';
export default {
    name: 'ImageCard',
    props: {
        buttonList: {
            type: Array,
            default: () => [],
        },
        cardInit: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        const rootNames = {
            'Why': 'Why (隐喻的目的)',
            'What': 'What (隐喻的本体，数据语义)',
            'How': 'How (隐喻的映射方式)',
        }
        return {
            rootNames: rootNames,
            rootKeys: Object.keys(rootNames),
            infoVisible: false,
            dialogInfo: {
                anno: {},
            },
            user: '',
            annoInput: '',
            editVisible: false,
            editImageUrl: '',
            editInput: '',
            editName: '',
            card: this.cardInit,
        }
    },
    computed: {

    },
    methods: {
      imageUrl(name, thumb=0) {
        return '/api/image?name=' + name + (thumb ? '&thumb=1' : '');
      },
      recommendByImage(name) {
        this.$emit('recommend', name);
      },
      // edit card
      handleCardEdit(name) {
        const that = this;
        axios.post('/api/imageinfo', {name: name}).then(function(response) {
          console.log(response.data);
          that.dialogInfo = {
            name: name,
            url: that.imageUrl(name),
            coding: response.data.coding,
            anno: response.data.anno,
            title: response.data.title,
            description: response.data.description,
            keywords: response.data.keywords,
          };
          that.editInput = JSON.stringify(that.card.design, null, 2);
          that.editVisible = true;
          that.editImageUrl = that.imageUrl(name);
          that.editName = name;
        });
      },
      handleDelete(name) {
        this.$emit('delete', name);
      },
      fastAnno(name) {
        // copy this.coding[name] to tmp
        const tmp = JSON.parse(JSON.stringify(this.card.design));
        if (tmp['What'].length === 1 && tmp['What'][0] === '') {
          tmp['What'] = ['领域语义'];
          tmp['How'] = ['形状映射'];
          tmp['Why'] = ['主题'];
        } else if (tmp['What'].length === 1 && tmp['What'][0] === '动态语义') {
          tmp['What'] = ['关系语义'];
        } else if (tmp['What'].length === 1 && tmp['What'][0] === '领域语义') {
          tmp['What'] = ['物体语义'];
        } else  {
          let cnt = 0;
          let le = tmp['What'].length;
          for (let i = 0; i < le; i++) {
            if (tmp['What'][i] === '属性语义' && tmp['Why'][i] === '数据') {
              tmp['Why'][i] = '主题';
              cnt += 1;
              this.$message({
                message: `change: ${i} 数据->主题`,
                type: 'info',
                duration: 3000,
              });
            } else if (tmp['What'][i] === '属性语义' && tmp['Why'][i] === '主题') {
              tmp['Why'][i] = '情感';
              cnt += 1;
              this.$message({
                message: `change: ${i} 主题->情感`,
                type: 'info',
                duration: 3000,
              });
            }
          }
          if (cnt === 0) return;
          // this.$message({
          //   message: '不是空的，不可快速标注',
          //   type: 'warning',
          //   duration: 3000,
          // });
          // return;
        }
        this.$message({
            message: '快速标注成功',
            type: 'info',
            duration: 3000,
        });
        this.editInput = JSON.stringify(tmp, null, 2);
        this.editName = name;
        this.saveEdit();
      },
      // star image
      starImage(name) {
        const that = this;
        axios.post('/api/imagestar', {
          name: name,
        }).then(function(response) {
          // console.log(response.data);
          let stars = response.data.stars;
          that.card.starred = stars.includes(name);
          that.$message({
              message: that.card.starred?'收藏成功':'取消收藏成功',
              type: 'success',
              duration: 3000,
          });
        });
      },
      handleRecover(name) {
        this.$emit('recover', name);
      },
      // click card show detail
      handleClickCard(name) {
        // console.log(name);
        const that = this;
        axios.post('/api/imageinfo', {name: name}).then(function(response) {
          // console.log(response.data);
          that.dialogInfo = {
            name: name,
            url: that.imageUrl(name),
            coding: response.data.coding,
            anno: response.data.anno,
            title: response.data.title,
            description: response.data.description,
            keywords: response.data.keywords,
          };
          if (that.user in that.dialogInfo.anno) {
            that.annoInput = that.dialogInfo.anno[that.user];
          } else {
            that.annoInput = '';
          }
          that.infoVisible = true;
        });
      },
      // annotate images
      saveAnno() {
        const that = this;
        if (that.annoInput === '') {
          return;
        }
        axios.post('/api/imageanno', {
          name: that.dialogInfo.name,
          user: that.user,
          anno: that.annoInput,
        }).then(function(response) {
          // console.log(response.data);
          that.dialogInfo.anno = response.data;
        });
      },
      searchAnno() {
        const that = this;
        if ((that.user in that.dialogInfo.anno) && that.annoInput === '') {
          that.annoInput = that.dialogInfo.anno[that.user];
        }
      },
      // set flag
      setFlag(flag) {
        const that = this;
        axios.post('/api/imageflag', {
          name: that.dialogInfo.name,
          flag: flag,
        }).then(function() {
          // console.log(response.data);
          that.$message({
              message: flag===1?'标记成功':'去除标记成功',
              type: 'success',
              duration: 3000,
          });
          that.card.flagged = flag===1;
        });
      },
      saveEdit() {
        const that = this;
        axios.post('/api/codingedit', {
          name: that.editName,
          coding: JSON.parse(that.editInput),
        }).then(function(response) {
          if (response.data.success) {
            that.$message({
                message: '修改成功',
                type: 'success',
                duration: 3000,
            });
            that.card.design = JSON.parse(that.editInput);
            that.editVisible = false;
            console.log(that.card.design);
          } else {
            that.$message({
                message: '修改失败: ' + response.data.message,
                type: 'error',
                duration: 3000,
            });
          }
        });
      },
    },
    mounted() {
      // console.log(this.card);
    }
};
</script>